/* InkMerge Studio — rendered preview export (PNG), Customer + Production modes */
(function () {
  const FONTS = window.IM_FONTS;
  const printHex = (pc) => (pc === "White" ? "#FFFFFF" : "#1B1A19");

  function loadImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.onload = () => res(img);
      img.onerror = rej;
      img.crossOrigin = "anonymous";
      img.src = src;
    });
  }

  // Use the live, always-rendered export garment — photo if present, else SVG.
  async function garmentImage() {
    const host = document.querySelector("[data-export-garment]");
    if (!host) return null;
    const mock = host.querySelector("img[data-mock]");
    if (mock && mock.getAttribute("src")) {
      try { return await loadImage(mock.getAttribute("src")); } catch (e) {}
    }
    const svg = host.querySelector("svg");
    if (!svg) return null;
    const clone = svg.cloneNode(true);
    clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    clone.setAttribute("width", "400");
    clone.setAttribute("height", "500");
    const str = new XMLSerializer().serializeToString(clone);
    const url = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(str);
    try { return await loadImage(url); } catch (e) { return null; }
  }

  function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  // opts: { product, design, totals, safe, warnings, mode }
  async function renderProof(opts) {
    const { product, design, totals, safe, warnings = [], mode = "customer", designId } = opts;
    const production = mode === "production";
    if (document.fonts && document.fonts.ready) { try { await document.fonts.ready; } catch (e) {} }

    const scale = 2.6;
    const gImg = await garmentImage();
    const arHW = (gImg && gImg.naturalWidth) ? (gImg.naturalHeight / gImg.naturalWidth) : (500 / 400);
    const GB = { x: 130, y: 96, w: 400 * scale, h: 400 * scale * arHW };
    const W = GB.x * 2 + GB.w;
    const footerY = GB.y + GB.h + 40;
    const footerH = production ? 540 : 280;
    const H = footerY + footerH;

    const cv = document.createElement("canvas");
    cv.width = W; cv.height = H;
    const ctx = cv.getContext("2d");
    if (!ctx) throw new Error("Preview canvas is unavailable.");

    ctx.fillStyle = production ? "#FAFAF8" : "#F6F1E8";
    ctx.fillRect(0, 0, W, H);

    ctx.textBaseline = "alphabetic";
    ctx.fillStyle = "#171412";
    ctx.font = "800 34px 'Hanken Grotesk', sans-serif";
    ctx.fillText("InkMerge", 130, 60);
    ctx.fillStyle = "#756B61";
    ctx.font = "600 18px 'Hanken Grotesk', sans-serif";
    const tag = production ? "PRODUCTION PREVIEW" : "Design Preview";
    ctx.textAlign = "right";
    ctx.fillText(tag, W - 130, 60);
    ctx.textAlign = "left";

    ctx.save();
    roundRect(ctx, GB.x - 30, GB.y - 20, GB.w + 60, GB.h + 40, 18);
    ctx.fillStyle = production ? "#FFFFFF" : "#FBF7F0";
    ctx.shadowColor = "rgba(40,26,12,0.10)"; ctx.shadowBlur = 30; ctx.shadowOffsetY = 12;
    ctx.fill();
    ctx.restore();

    if (gImg) ctx.drawImage(gImg, GB.x, GB.y, GB.w, GB.h);

    const sa = { x: GB.x + safe.x / 100 * GB.w, y: GB.y + safe.y / 100 * GB.h, w: safe.w / 100 * GB.w, h: safe.h / 100 * GB.h };
    ctx.save();
    ctx.strokeStyle = production ? "rgba(241,90,36,0.7)" : "rgba(0,0,0,0.22)";
    ctx.lineWidth = production ? 2 : 1.4;
    ctx.setLineDash([8, 6]);
    ctx.strokeRect(sa.x, sa.y, sa.w, sa.h);
    ctx.restore();

    const layers = design.layers.filter(l => !l.hidden);
    if (!layers.length) throw new Error("No visible design layers are available for the preview.");
    for (const l of layers) {
      const cx = GB.x + l.x / 100 * GB.w;
      const cy = GB.y + l.y / 100 * GB.h;
      ctx.save();
      try {
        ctx.translate(cx, cy);
        ctx.rotate((l.rotation || 0) * Math.PI / 180);
        if (l.type === "text") {
          const fpx = l.fontSize / 100 * GB.w;
          ctx.fillStyle = printHex(design.printColor);
          ctx.font = "700 " + fpx + "px " + FONTS.familyOf(l.font);
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          const lines = (l.text || "Text").split("\n");
          const lh = fpx * 1.08;
          lines.forEach((ln, i) => ctx.fillText(ln, 0, (i - (lines.length - 1) / 2) * lh));
        } else if (l.type === "art") {
          if (!l.src) throw new Error("Artwork layer is missing its source.");
          const im = await loadImage(l.src);
          const wpx = l.w / 100 * GB.w;
          const hpx = wpx / (l.aspect || (im.width / im.height) || 1);
          if (!Number.isFinite(wpx) || !Number.isFinite(hpx) || wpx <= 0 || hpx <= 0) {
            throw new Error("Artwork layer has invalid dimensions.");
          }
          ctx.drawImage(im, -wpx / 2, -hpx / 2, wpx, hpx);
        } else {
          throw new Error("Unsupported visible layer type: " + String(l.type || "unknown"));
        }
      } finally {
        ctx.restore();
      }
    }

    let fy = footerY + 6;
    ctx.fillStyle = "#171412";
    ctx.font = "800 26px 'Hanken Grotesk', sans-serif";
    ctx.fillText(product.title, 130, fy + 22);
    ctx.fillStyle = "#756B61";
    ctx.font = "500 17px 'Hanken Grotesk', sans-serif";
    ctx.fillText(design.color + "  ·  " + (design.location === "back" ? "Back" : "Front") + "  ·  " + design.printColor + " ink", 130, fy + 48);

    ctx.textAlign = "right";
    ctx.fillStyle = "#171412";
    ctx.font = "800 30px 'Hanken Grotesk', sans-serif";
    ctx.fillText("$" + totals.total.toFixed(2), W - 130, fy + 26);
    ctx.fillStyle = "#756B61";
    ctx.font = "500 15px 'Hanken Grotesk', sans-serif";
    ctx.fillText(totals.qty + " pcs · est.", W - 130, fy + 48);
    ctx.textAlign = "left";

    fy += 78;
    ctx.strokeStyle = "rgba(0,0,0,0.10)"; ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(130, fy); ctx.lineTo(W - 130, fy); ctx.stroke();
    fy += 30;

    ctx.fillStyle = "#9C9285"; ctx.font = "700 13px 'Hanken Grotesk', sans-serif";
    ctx.fillText("SIZES", 130, fy);
    ctx.fillStyle = "#171412"; ctx.font = "500 17px 'Hanken Grotesk', sans-serif";
    const sizeStr = design.layers && totals.qty ? product.sizes.filter(s => (design.quantities[s.size] || 0) > 0).map(s => s.size + " ×" + design.quantities[s.size]).join("   ") : "—";
    ctx.fillText(sizeStr || "—", 230, fy);
    fy += 34;

    if (design.notes) {
      ctx.fillStyle = "#9C9285"; ctx.font = "700 13px 'Hanken Grotesk', sans-serif";
      ctx.fillText("NOTES", 130, fy);
      ctx.fillStyle = "#171412"; ctx.font = "500 16px 'Hanken Grotesk', sans-serif";
      ctx.fillText(design.notes.slice(0, 80), 230, fy);
      fy += 32;
    }

    if (production) {
      fy += 10;
      ctx.fillStyle = "#9C9285"; ctx.font = "700 13px 'Hanken Grotesk', sans-serif";
      ctx.fillText("PRINT SPECS", 130, fy); fy += 26;
      ctx.fillStyle = "#171412"; ctx.font = "500 15px 'Hanken Grotesk', sans-serif";
      const chartRow = product.chart.find(r => (design.quantities[r.size] || 0) > 0) || product.chart[0];
      ctx.fillText("Canvas ref: 400 × 500 px  ·  Print area: " + safe.w.toFixed(0) + "% × " + safe.h.toFixed(0) + "% of garment  ·  Garment width ~" + (chartRow ? chartRow.width : "—") + '"', 130, fy);
      fy += 30;
      ctx.fillStyle = "#9C9285"; ctx.font = "700 13px 'Hanken Grotesk', sans-serif";
      ctx.fillText("LAYERS (x%, y%, scale, rotation)", 130, fy); fy += 24;
      ctx.font = "500 14px 'Hanken Grotesk', sans-serif"; ctx.fillStyle = "#171412";
      design.layers.forEach((l, i) => {
        const sz = l.type === "text" ? "font " + l.fontSize.toFixed(1) + "%" : "w " + l.w.toFixed(1) + "%";
        const nm = (l.name || (l.type === "text" ? l.text : "artwork") || "layer").slice(0, 26);
        ctx.fillText((i + 1) + ". " + l.type.toUpperCase() + " · " + nm + " · x" + l.x.toFixed(1) + " y" + l.y.toFixed(1) + " · " + sz + " · " + (l.rotation || 0) + "°" + (l.hidden ? " · HIDDEN" : ""), 130, fy);
        fy += 22;
      });
      if (warnings.length) {
        fy += 8;
        ctx.fillStyle = "#B0863A"; ctx.font = "700 13px 'Hanken Grotesk', sans-serif";
        ctx.fillText("WARNINGS", 130, fy); fy += 22;
        ctx.font = "500 14px 'Hanken Grotesk', sans-serif";
        warnings.forEach(w => { ctx.fillText("⚠ " + w, 130, fy); fy += 21; });
      }
      ctx.strokeStyle = "rgba(0,0,0,0.5)"; ctx.lineWidth = 1.5;
      const cm = 18;
      [[GB.x, GB.y], [GB.x + GB.w, GB.y], [GB.x, GB.y + GB.h], [GB.x + GB.w, GB.y + GB.h]].forEach(([x, y], i) => {
        const sx = i % 2 ? -1 : 1, sy = i < 2 ? 1 : -1;
        ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x + sx * cm, y); ctx.moveTo(x, y); ctx.lineTo(x, y + sy * cm); ctx.stroke();
      });
      ctx.fillStyle = "#9C9285"; ctx.font = "500 13px 'Hanken Grotesk', sans-serif";
      ctx.fillText(designId + "  ·  generated " + new Date().toLocaleString(), 130, H - 28);
    } else {
      fy += 10;
      ctx.fillStyle = "#51694A"; ctx.font = "600 15px 'Hanken Grotesk', sans-serif";
      ctx.fillText("✓ Review this preview before adding to cart · keep the design ID for support", 130, fy);
      ctx.fillStyle = "#9C9285"; ctx.font = "500 13px 'Hanken Grotesk', sans-serif";
      ctx.fillText(designId, 130, H - 26);
    }

    return cv;
  }

  async function downloadProofPNG(opts) {
    const cv = await renderProof(opts);
    const a = document.createElement("a");
    a.href = cv.toDataURL("image/png");
    a.download = (opts.designId || "inkmerge") + (opts.mode === "production" ? "-production-preview" : "-preview") + ".png";
    a.click();
    return a.href;
  }

  async function proofDataURL(opts) {
    const cv = await renderProof(opts);
    return cv.toDataURL("image/png");
  }

  window.IM_PROOF = { renderProof, downloadProofPNG, proofDataURL };
})();
